export default __webpack_public_path__ + "static/media/2434.1dac5241.png";